import angular from 'angular';

import PoiPhonePreviewComponent from './poi-phone-preview.component';

const PoiPhonePreview = angular
    .module('control-room.poi.components.poi-phone-preview', [])
    .component('crPoiPhonePreview', PoiPhonePreviewComponent);

export default PoiPhonePreview;
